<script lang="ts">
	import Image from '$lib/storyblok/components/image.svelte';
	import PageGrid16 from '$lib/storyblok/components/pageGrid16.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage } from '$lib/storyblok/types';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			title: string;
			items: Array<{
				headline: string;
				subheadline?: string;
				asset: SbImage;
			}>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<article use:editable={content} class="bg-brown-6 lg:bg-white lg:py-9">
	<PageGrid16 margin gridClass="bg-brown-6 lg:rounded-2xl py-12 lg:py-17">
		<div
			class="col-span-full row-start-1 lg:col-span-7 lg:col-start-2 xl:col-span-6 xl:col-start-2"
		>
			<h1
				class="text-[44px]/[108%] tracking-[-.44px] text-brown-1 max-lg:mb-7 lg:text-[64px]/[110%] lg:tracking-[-.64px]"
			>
				{content.title}
			</h1>
		</div>
		<div class="item-grid flex flex-wrap gap-x-8 gap-y-6 lg:gap-x-12 lg:gap-y-12">
			{#each content.items as item}
				<div class="">
					<Image
						src={item.asset.filename}
						alt={item.asset.alt}
						title={item.asset.title}
						class="mb-2 h-24 w-24 lg:mb-4 lg:h-32 lg:w-32"
						width={512}
						height={512}
					/>
					<div
						class="text-[20px]/[140%] tracking-[-.2px] text-brown-1 lg:text-pretty lg:text-[24px]/[120%] lg:tracking-[-.24px]"
					>
						{item.headline}
					</div>
					{#if item.subheadline && item.subheadline.length > 0}
						<div
							class="mt-1 text-pretty text-[14px]/[160%] text-brown-4 lg:mt-2 lg:text-[16px]/[150%]"
						>
							{item.subheadline}
						</div>
					{/if}
				</div>
			{/each}
		</div>
	</PageGrid16>
</article>

<style lang="scss">
	div.item-grid {
		display: grid;
		grid-column: 1 / -1;
		grid-template-columns: repeat(2, 1fr);

		@media screen and (min-width: 1024px) {
			grid-row: 1;
			grid-column-start: 2;
			grid-column-end: 16;
			grid-template-columns: repeat(4, 1fr);

			& > div:nth-child(-n + 1) {
				grid-column-start: 3;
			}
		}
	}
</style>
